module.exports = __webpack_public_path__ + "img/magnifier.a839e8f9.svg";